import { EventType } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import * as React from "react";
import { loginRequest } from "./useAuth";
import LinearProgress from "@material-ui/core/LinearProgress";
import { getAccessToken } from "./auth";
import { useAppDispatch } from "app/store";
import { setInfo } from "./store/auth.slice";

export const ProviderState = React.createContext<any>({});

const ProviAuth = ({ children }) => {
  const dispatch = useAppDispatch();
  const { instance } = useMsal();
  const [isAuthenticated, setIsAuthenticated] = React.useState(false);

  React.useEffect(() => {
    const accounts = instance.getAllAccounts();
    if (accounts.length > 0) {
      instance.setActiveAccount(accounts[0]);
    }

    instance.addEventCallback((event) => {
      if (
        event.eventType === EventType.LOGIN_SUCCESS &&
        event.payload.account
      ) {
        const account = event.payload.account;
        instance.setActiveAccount(account);
      }
    });

    (async () => {
      const redirectResponse = await instance.handleRedirectPromise();
      if (redirectResponse !== null) {
        dispatch(setInfo(redirectResponse.account));
        sessionStorage.setItem(
          "userInfo",
          JSON.stringify(redirectResponse.account)
        );
        let accessToken = redirectResponse.accessToken;
        getAccessToken(accessToken, setIsAuthenticated, dispatch);
      } else {
        const account = instance.getAllAccounts()[0];

        if (!account) {
          instance.loginRedirect(loginRequest);
          return;
        }

        const accessTokenRequest = {
          ...loginRequest,
          account: account,
          prompt: "none",
          responseType: "id_token token",
        };

        try {
          const accessTokenResponse = await instance.acquireTokenSilent(
            accessTokenRequest
          );
          dispatch(setInfo(accessTokenResponse.account));

          sessionStorage.setItem(
            "userInfo",
            JSON.stringify(accessTokenResponse.account)
          );

          let accessToken = accessTokenResponse.accessToken;
          getAccessToken(accessToken, setIsAuthenticated, dispatch);
        } catch (error) {
          console.error("Token acquisition failed", error);
          instance.acquireTokenRedirect(accessTokenRequest);
        }
      }
    })();
  }, [instance, dispatch]);

  return (
    <ProviderState.Provider value={{}}>
      {!isAuthenticated ? <LinearProgress /> : children}
    </ProviderState.Provider>
  );
};

export default ProviAuth;
